import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import { g as get, w as getOrSelect, r as rjPlugin, S as SUCCESS } from '../../rjPlugin.es.js';
import rjListInsert, { TYPE } from '../listInsert/index.es.js';
import rjListUpdate from '../listUpdate/index.es.js';
import rjListDelete, { TYPE as TYPE$1 } from '../listDelete/index.es.js';
import qs from 'query-string';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toArray';
import 'rxjs';
import '@babel/runtime/helpers/esm/typeof';
import 'object-path-immutable';
import '@babel/runtime/helpers/esm/defineProperty';
import 'rxjs/operators';

// Util for getting pagination params from url
var pickParamsFromUrl = function pickParamsFromUrl(url, pick) {
  if (url) {
    var params = qs.parse(qs.extract(url));
    return pick(params);
  }

  return null;
};

var pickPage = function pickPage(_ref) {
  var page = _ref.page;
  return {
    page: +(page || 1)
  };
};

var nextPreviousPaginationAdapter = {
  // Getter for list of stuff string or fn selector from the response
  list: 'results',
  // Count of total stuff
  count: 'count',
  current: function current(_ref2) {
    var next = _ref2.next,
        previous = _ref2.previous,
        count = _ref2.count;

    var _ref3 = pickParamsFromUrl(next, pickPage) || {
      page: null
    },
        nextPage = _ref3.page;

    var _ref4 = pickParamsFromUrl(previous, pickPage) || {
      page: null
    },
        prevPage = _ref4.page;

    if (nextPage !== null) {
      return {
        page: nextPage - 1
      };
    } else if (prevPage !== null) {
      return {
        page: prevPage + 1
      };
    } else if (count > 0) {
      return {
        page: 1
      };
    } else {
      return null;
    }
  },
  // Next params
  next: function next(_ref5) {
    var _next = _ref5.next;
    return pickParamsFromUrl(_next, pickPage);
  },
  // Prev params
  previous: function previous(_ref6) {
    var _previous = _ref6.previous;
    return pickParamsFromUrl(_previous, pickPage);
  }
};

var pickLimitOffset = function pickLimitOffset(_ref7) {
  var limit = _ref7.limit,
      offset = _ref7.offset;
  return {
    limit: +(limit !== null && limit !== void 0 ? limit : 0),
    offset: +(offset !== null && offset !== void 0 ? offset : 0)
  };
};

var limitOffsetPaginationAdapter = {
  // Getter for list of stuff string or fn selector from the response
  list: 'results',
  // Count of total stuff
  count: 'count',
  current: function current(_ref8) {
    var next = _ref8.next,
        previous = _ref8.previous,
        count = _ref8.count;

    var _ref9 = pickParamsFromUrl(previous, pickLimitOffset) || {
      limit: null,
      offset: null
    },
        prevLimit = _ref9.limit,
        prevOffset = _ref9.offset;

    var _ref10 = pickParamsFromUrl(next, pickLimitOffset) || {
      limit: null,
      offset: null
    },
        nextLimit = _ref10.limit,
        nextOffset = _ref10.offset;

    if (prevLimit !== null) {
      return {
        limit: prevLimit,
        offset: prevLimit + prevOffset
      };
    } else if (nextLimit !== null) {
      return {
        limit: nextLimit,
        offset: nextLimit - nextOffset
      };
    } else if (count > 0) {
      return {
        page: 1
      };
    } else {
      return null;
    }
  },
  // Next params
  next: function next(_ref11) {
    var _next2 = _ref11.next;
    return pickParamsFromUrl(_next2, pickLimitOffset);
  },
  // Prev params
  previous: function previous(_ref12) {
    var _previous2 = _ref12.previous;
    return pickParamsFromUrl(_previous2, pickLimitOffset);
  }
};

// Data reducer for a list paginated
function makeListDataReducer(paginationAdapter, customListReducer, customPaginationReducer) {
  var defaultListReducer = function defaultListReducer(prevState, _ref) {
    var data = _ref.payload.data,
        meta = _ref.meta;
    var newList = getOrSelect(data, paginationAdapter.list);

    if (meta && meta.append && Array.isArray(prevState)) {
      return prevState.concat(newList);
    }

    if (meta && meta.prepend && Array.isArray(prevState)) {
      return newList.concat(prevState);
    }

    return newList;
  };

  var defaultPaginationReducer = function defaultPaginationReducer(prevState, _ref2) {
    var _ref2$payload = _ref2.payload,
        data = _ref2$payload.data;
        _ref2$payload.params;
    return {
      count: +getOrSelect(data, paginationAdapter.count),
      current: getOrSelect(data, paginationAdapter.current),
      next: getOrSelect(data, paginationAdapter.next),
      previous: getOrSelect(data, paginationAdapter.previous)
    };
  };

  var listReducer = typeof customListReducer === 'function' ? customListReducer : defaultListReducer;
  var paginationReducer = typeof customPaginationReducer === 'function' ? customPaginationReducer : defaultPaginationReducer;
  return function (prevState, action) {
    return {
      list: listReducer(get(prevState, 'list'), action),
      pagination: paginationReducer(get(prevState, 'pagination'), action)
    };
  };
}

var makeListSelectors = function makeListSelectors(getData, pageSize) {
  var getList = function getList(state) {
    var data = getData(state);
    return data === null ? null : data.list;
  };

  var getCount = function getCount(state) {
    var data = getData(state);
    return data === null ? null : data.pagination.count;
  };

  var getNumPages = function getNumPages(state) {
    var overridePageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pageSize;

    if (overridePageSize === undefined) {
      throw new Error('[reactRj - rjList] Please pass a pageSize argument to getNumPages' + 'selector or define a default page size (config.pageSize)');
    }

    var count = getCount(state);
    return count === null ? null : Math.ceil(count / overridePageSize);
  };

  var hasNext = function hasNext(state) {
    var data = getData(state);
    return data === null ? false : data.pagination.next !== null;
  };

  var hasPrev = function hasPrev(state) {
    var data = getData(state);
    return data === null ? false : data.pagination.previous !== null;
  };

  var getNext = function getNext(state) {
    var data = getData(state);
    return data === null ? null : data.pagination.next;
  };

  var getPrev = function getPrev(state) {
    var data = getData(state);
    return data === null ? null : data.pagination.previous;
  };

  var getCurrent = function getCurrent(state) {
    var data = getData(state);
    return data === null ? null : data.pagination.current;
  };

  var getPagination = function getPagination(state) {
    return {
      count: getCount(state),
      numPages: getNumPages(state),
      hasNext: hasNext(state),
      hasPrev: hasPrev(state),
      current: getCurrent(state),
      next: getNext(state),
      prev: getPrev(state)
    };
  };

  return {
    getList: getList,
    getCount: getCount,
    getNumPages: getNumPages,
    hasNext: hasNext,
    hasPrev: hasPrev,
    getNext: getNext,
    getPrev: getPrev,
    getCurrent: getCurrent,
    getPagination: getPagination
  };
};

function rjList(config) {
  // NOTE: OLD CHECK MAYBE REMOVE CAUSE WE HAVE TYPPEEEES!
  if (!(config !== null && config !== void 0 && config.pagination)) throw new Error('[reactRj - rjList] Please define a pagination adapter (config.pagination)');
  var dataReducer = makeListDataReducer(config.pagination, config.customListReducer, config.customPaginationReducer);
  return rjPlugin(rjListInsert({
    path: 'data.list',
    warnPagination: false
  }), rjListUpdate({
    path: 'data.list'
  }), rjListDelete({
    path: 'data.list',
    warnPagination: false
  }), {
    selectors: function selectors(_ref3) {
      var getData = _ref3.getData;
      return makeListSelectors(getData, config.pageSize);
    },
    reducer: function reducer(oldReducer) {
      return function (state, action) {
        if (action.type === SUCCESS) {
          return _objectSpread(_objectSpread({}, state), {}, {
            pending: false,
            data: dataReducer(state.data, action)
          });
        } else if (action.type === TYPE && config.insertItemTouchPagination !== false) {
          var _nextState$data, _nextState$data$pagin;

          var nextState = oldReducer(state, action);
          var count = (_nextState$data = nextState.data) === null || _nextState$data === void 0 ? void 0 : (_nextState$data$pagin = _nextState$data.pagination) === null || _nextState$data$pagin === void 0 ? void 0 : _nextState$data$pagin.count;

          if (typeof count === 'number' && !isNaN(count)) {
            var _nextState$data2;

            return _objectSpread(_objectSpread({}, nextState), {}, {
              data: _objectSpread(_objectSpread({}, nextState.data), {}, {
                pagination: _objectSpread(_objectSpread({}, (_nextState$data2 = nextState.data) === null || _nextState$data2 === void 0 ? void 0 : _nextState$data2.pagination), {}, {
                  count: count + 1
                })
              })
            });
          }

          return nextState;
        } else if (action.type === TYPE$1 && config.deleteItemTouchPagination !== false) {
          var _nextState$data3, _nextState$data3$pagi;

          var _nextState = oldReducer(state, action);

          var _count = (_nextState$data3 = _nextState.data) === null || _nextState$data3 === void 0 ? void 0 : (_nextState$data3$pagi = _nextState$data3.pagination) === null || _nextState$data3$pagi === void 0 ? void 0 : _nextState$data3$pagi.count;

          if (typeof _count === 'number' && !isNaN(_count)) {
            var _nextState$data4;

            return _objectSpread(_objectSpread({}, _nextState), {}, {
              data: _objectSpread(_objectSpread({}, _nextState.data), {}, {
                pagination: _objectSpread(_objectSpread({}, (_nextState$data4 = _nextState.data) === null || _nextState$data4 === void 0 ? void 0 : _nextState$data4.pagination), {}, {
                  count: _count - 1
                })
              })
            });
          }

          return _nextState;
        } else {
          return oldReducer(state, action);
        }
      };
    }
  });
}

export default rjList;
export { limitOffsetPaginationAdapter, nextPreviousPaginationAdapter, pickParamsFromUrl };
